import { Link } from 'react-router-dom';

/** Dezenter Footer mit Pflichtangabe-Links (Impressum, Datenschutz, AGB).
 *  Erscheint unter dem Hauptinhalt jedes Layouts sowie auf der Login-Seite.
 *  Variant 'dark' wird auf Login-Hintergrund verwendet (heller Text).
 */
export default function LegalFooter({ variant = 'light' }) {
  const isDark = variant === 'dark';
  const base = isDark
    ? 'text-slate-400 hover:text-white'
    : 'text-slate-500 hover:text-slate-900';
  const border = isDark ? 'border-slate-700' : 'border-slate-200';
  const divider = isDark ? 'text-slate-600' : 'text-slate-300';

  return (
    <footer
      className={`mt-auto border-t ${border} text-xs`}
      data-testid="legal-footer"
    >
      <div className="px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className={isDark ? 'text-slate-500' : 'text-slate-400'}>
          © {new Date().getFullYear()} Immo Verwalter
        </p>
        <nav className="flex items-center gap-4" aria-label="Rechtliche Hinweise">
          <Link to="/impressum" className={`${base} transition-colors`} data-testid="footer-impressum-link">
            Impressum
          </Link>
          <span className={divider} aria-hidden>·</span>
          <Link to="/datenschutz" className={`${base} transition-colors`} data-testid="footer-datenschutz-link">
            Datenschutz
          </Link>
          <span className={divider} aria-hidden>·</span>
          <Link to="/agb" className={`${base} transition-colors`} data-testid="footer-agb-link">
            AGB
          </Link>
        </nav>
      </div>
    </footer>
  );
}
